import React from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';

import { ActiveCompetitionList } from '../../ActiveCompetitionList';
import { SectionHeader } from '../../SectionHeader';
import { useTranslator } from '../../../i18n/useTranslator';

const styles = () => createStyles({});

type Props = WithStyles<typeof styles>;

const CompetitionJuryMemberCompetitionsScreenComponent: React.FunctionComponent<Props> = () => {
  const { t } = useTranslator();

  return (
    <div>
      <SectionHeader title={t('competitions')} />
      <ActiveCompetitionList rolePath={'competition-jury-member'} />
    </div>
  );
};

export const CompetitionJuryMemberCompetitionsScreen = withStyles(styles)(CompetitionJuryMemberCompetitionsScreenComponent);
